import { render, staticRenderFns } from "./ContentItemEditorClassic.vue?vue&type=template&id=dd168ec4&"
import script from "./ContentItemEditorClassic.vue?vue&type=script&lang=js&"
export * from "./ContentItemEditorClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentItemEditorClassic.vue"
export default component.exports